import type { YearVehicleModelResponseDTO } from '~/dto/Insurance/yearVehicleModelDTO';
import type { YearVehicleModelEntity } from '~/domain/Insurance/yearsVehicleModelEntity';

export const yearVehicleModelResponseMapper = ({
  success,
  resultData,
}: YearVehicleModelResponseDTO): YearVehicleModelEntity => {
  if (success && resultData.length > 0) {
    return <YearVehicleModelEntity>{
      success,
      yearVehicleModels: resultData,
    };
  }
  return { success: false, yearVehicleModels: [] };
};
